import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery } from "../../../../graphql/generated.tsx";
import { Card } from "flowbite-react";
import { Link } from "react-router-dom";
import Loader from "../../../../components/Loader.jsx";

const ModuleCampusListing = () => {
  const [campus, setCampus] = useState([]);
  const [Isload, setIsload] = useState(true);

  
   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);
  
  const { data, loading, error } = useGetAllCampusesQuery();
  useEffect(() => {
    if (data) {
      setCampus(data.allCampus);
    }
  }, [data]);
  if (loading || Isload) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-10">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
             Module Reports
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {campus.map((campus) => (
            <Link to={`/admin/reports/module/${campus.name}`} key={campus.id}>
              <Card className="h-full">
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  {campus.name}
                </h5>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default ModuleCampusListing;
